import { useQuery } from '@apollo/client';
import { GridEventListener, useGridApiRef } from '@mui/x-data-grid-premium';
import { useEffect, useState } from 'react';

import GET_CHARGES from '../../../../api/apollo/query/GetCharges';
import { useAuth } from '../../../../api/auth';
import { CustomDataGrid } from '../../../../components/CustomDataGrid';
import TableToolbar from '../../../../components/Table/TableToolbar';
import { DefaultTableProps } from '../../../../components/Table/types';
import { IndictmentCharge } from '../../../../types';
import columns from './columns';

export const Charges = ({ shrinkTitle, hideHeaders, showHeaders }: DefaultTableProps) => {
    const { user } = useAuth();
    const apiRef = useGridApiRef();
    const [rows, setRows] = useState<IndictmentCharge[]>([]);

    const { loading } = useQuery(GET_CHARGES, {
        onCompleted: ({ indictmentCharges }: { indictmentCharges: IndictmentCharge[] }) => {
            setRows(indictmentCharges);
        },
    });
    useEffect(() => {
        const handleEvent: GridEventListener<'rowsScroll'> = (params) => {
            params.top > 5 ? hideHeaders() : showHeaders();
        };

        apiRef.current.subscribeEvent('rowsScroll', handleEvent);
    }, [apiRef, hideHeaders, showHeaders]);

    return (
        <CustomDataGrid
            apiRef={apiRef}
            getRowId={(row) => row.id}
            rowGroupingColumnMode="single"
            columns={columns}
            rows={rows}
            checkboxSelection={false}
            loading={loading}
            hideFooterSelectedRowCount
            components={{ Toolbar: TableToolbar }}
            componentsProps={{
                toolbar: {
                    title: 'Charges',
                    showTitle: shrinkTitle,
                    csvExportEnabled: user?.permissions?.map(({ codename }) => codename).includes('can_export_tables'),
                    tableApi: apiRef.current,
                },
            }}
            experimentalFeatures={{ aggregation: true }}
        />
    );
};

export default Charges;
